import { ReactNode } from 'react';

import { Typography } from '@mui/material';

import styled from 'styled-components';

interface SliderMarkLabelProps {
  label: string;
  align?: 'left' | 'right';
  labelPosition?: 'top' | 'bottom';
}

interface StyledSliderMarkLabelProps {
  $align?: 'left' | 'right';
  $labelPosition?: 'top' | 'bottom';
}

const StyledMarkContainer = styled.div<StyledSliderMarkLabelProps>`
  ${({ $align }) => {
    if ($align === 'left') return `margin-right: 50%;`;
    if ($align === 'right') return `margin-left: 50%;`;
    return;
  }}
  ${({ $labelPosition }) => {
    if ($labelPosition === 'top') return `top: -65px;`;
    return;
  }}
  position: relative;
  display: flex;
  justify-content: center;

  .label {
    position: absolute;
    ${({ $align }) => {
      if ($align === 'left') return `right: 5px;`;
      if ($align === 'right') return `left: 5px;`;
      return;
    }}
  }
`;

export const SliderMarkLabel = ({ label, align, labelPosition }: SliderMarkLabelProps) => {
  return (
    <StyledMarkContainer $align={align} $labelPosition={labelPosition}>
      <Typography className="label" variant="body1.bold">
        {label}
      </Typography>
    </StyledMarkContainer>
  );
};

interface StyledMarkProps {
  $start: number;
  $position?: 'top' | 'bottom';
}

const StyledMark = styled.div<StyledMarkProps>`
  position: absolute;
  left: ${({ $start }) => `${$start}%`};
  height: 30px;
  top: ${({ theme, $position }) => ($position === 'top' ? theme.spacing(-0.5) : theme.spacing(0.5))};
  border-left: 1px dashed ${({ theme }) => theme.palette.darkened.steel};
`;

interface MarkProps extends StyledMarkProps {
  percent?: ReactNode;
  label?: ReactNode;
}

export const Mark = ({ label, percent, ...styledProps }: MarkProps) => {
  return (
    <StyledMark {...styledProps}>
      <Typography
        variant="body2.semibold"
        textTransform="uppercase"
        lineHeight={1.5}
        marginTop={styledProps.$position === 'top' ? -6 : 5}
        display="flex"
        justifyContent="center"
        marginRight="100%"
        flexDirection={styledProps.$position === 'top' ? 'column-reverse' : 'column'}
        alignItems="center"
      >
        {percent && <b>{percent}</b>}
        <Typography variant="body2.semibold" sx={{ textDecoration: 'underline' }}>
          {label}
        </Typography>
      </Typography>
    </StyledMark>
  );
};
